import ErrorIcon from '@mui/icons-material/Error';
import DialogActions from '@zenbusiness/zui/DialogActions';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ContactCSErrorIcon = superstyled({
  tag: ErrorIcon,
  name: 'ContactCS',
  slot: 'ContactCSErrorIcon',
  styles: { fontSize: '3rem' },
});

export const TitleText = superstyled({
  tag: Text,
  name: 'ContactCS',
  slot: 'TitleText',
  styles: ({ theme }) => ({ marginTop: theme.spacing(2) }),
});

export const ActionsContainer = superstyled({
  tag: DialogActions,
  name: 'ContactCS',
  slot: 'ActionsContainer',
  styles: ({ theme }) => ({
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingInline: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }),
});
